import { render, staticRenderFns } from "./artifacts_list.vue.js?vue&type=template&id=3ed1aa04!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./artifacts_list.vue?vue&type=template&id=3ed1aa04"
import script from "./artifacts_list.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./artifacts_list.vue?vue&type=script&lang=js"
export * from "./artifacts_list.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./artifacts_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports